
import React from 'react';
import { Text } from '@mantine/core';
import { History } from 'lucide-react';

interface CustomerSelectionHeaderProps {
  hasLastActiveCustomer: boolean;
}

const CustomerSelectionHeader: React.FC<CustomerSelectionHeaderProps> = ({
  hasLastActiveCustomer
}) => {
  if (!hasLastActiveCustomer) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, marginTop: 8 }}>
      <History size={16} style={{ color: 'var(--mantine-color-dimmed)' }} />
      <Text size="sm" c="dimmed">Your last used customer is highlighted</Text>
    </div>
  );
};

export default CustomerSelectionHeader;
